import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useFileExplorerStore } from "@presentation/stores";
import { useJobSetupStore } from "@presentation/stores/JobSetupStore";
import { useLocation } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

const DIA_ANALYSIS_ID = "66666666-6666-6666-6666-666666666666";

export const ResetRawFileSelector: React.FC = () => {
  const location = useLocation();
  const resetGrid = useFileExplorerStore((state) => state.resetSelectedGridData);
  const { setJobRawFiles, resumeFromStepId } = useJobSetupStore(
    useShallow((state) => ({
      setJobRawFiles: state.setJobRawFiles,
      resumeFromStepId: state.CreateJobState.resumeFromStepId,
    })),
  );
  const isDiaAnalysisRerun = new URLSearchParams(location.search).has("rerunJobId") && resumeFromStepId === DIA_ANALYSIS_ID;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginRight: "0.75rem",
      }}
      title={isDiaAnalysisRerun ? "Raw files can only be added in DIA Analysis restart mode. Removing files is disabled." : undefined}
    >
      <Button
        disabled={isDiaAnalysisRerun}
        onClick={() => {
          resetGrid();
          setJobRawFiles([]);
        }}
      >
        Reset raw file selection
      </Button>
    </div>
  );
};
